import { edenAddToCart } from './eden-cart.js';

const moneyFormat = window.Theme?.moneyFormat || 'R$ {{amount}}';

function formatMoney(cents) {
  const amount = (cents / 100).toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
}

function initProductPage(root) {
  const product = JSON.parse(root.querySelector('[data-product-json]')?.textContent || '{}');
  if (!product?.variants?.length) return;

  const discountPct = Number(root.dataset.pixDiscount) || 5;
  const showPix = root.dataset.showPix !== 'false';

  const variantInput = root.querySelector('[data-eden-variant-id]');
  const specEl = root.querySelector('[data-eden-spec]');
  const basePriceEl = root.querySelector('[data-eden-base-price]');
  const pixPriceEl = root.querySelector('[data-eden-pix-price]');
  const simplePriceEl = root.querySelector('[data-eden-simple-price]');
  const mainImage = root.querySelector('[data-eden-main-image]');
  const totalsEl = root.querySelector('[data-eden-totals]');
  const mobilePriceEl = root.querySelector('[data-eden-mobile-price]');
  const form = root.querySelector('[data-eden-product-form], .eden-product-form');
  const qtyValue = root.querySelector('[data-eden-qty-value]');
  const qtyMinus = root.querySelector('[data-eden-qty-minus]');
  const qtyPlus = root.querySelector('[data-eden-qty-plus]');
  const paymentBtns = root.querySelectorAll('[data-eden-payment]');
  const thumbBtns = [...root.querySelectorAll('[data-eden-thumb]')];
  const optionGroups = root.querySelectorAll('[data-eden-option]');
  const galleryPrev = root.querySelector('[data-eden-gallery-prev]');
  const galleryNext = root.querySelector('[data-eden-gallery-next]');
  const mobileBuy = root.querySelector('[data-eden-mobile-buy]');

  let selectedOptions = product.options.map(
    (_, i) => product.variants.find((v) => v.available)?.[`option${i + 1}`] || product.variants[0][`option${i + 1}`]
  );
  let quantity = 1;
  let paymentMethod = 'pix';
  let currentMediaIndex = 0;

  const media = product.media?.length
    ? product.media
    : product.images?.map((src, i) => ({ preview_image: { src }, id: i })) || [];

  function findVariant() {
    return (
      product.variants.find((variant) => selectedOptions.every((val, i) => variant[`option${i + 1}`] === val)) ||
      product.variants[0]
    );
  }

  function calcPrices(variant) {
    const base = variant.compare_at_price > variant.price ? variant.compare_at_price : variant.price;
    const pix = showPix ? Math.round((base * (100 - discountPct)) / 100) : variant.price;
    const subtotal = base * quantity;
    const discount = paymentMethod === 'pix' && showPix ? Math.round((subtotal * discountPct) / 100) : 0;
    const afterDiscount = subtotal - discount;
    const total = afterDiscount;
    return { base, pix, subtotal, discount, total };
  }

  function setMedia(index) {
    if (!media.length || !mainImage) return;
    currentMediaIndex = (index + media.length) % media.length;
    const item = media[currentMediaIndex];
    const src = item?.preview_image?.src || item?.src;
    if (src) {
      mainImage.src = src;
      mainImage.srcset = '';
    }
    thumbBtns.forEach((t, j) => t.classList.toggle('is-active', j === currentMediaIndex));
  }

  function updateTotals(variant) {
    const p = calcPrices(variant);
    if (!totalsEl) return;
    totalsEl.innerHTML = `
      <div class="eden-totals__row"><span>Subtotal</span><span>${formatMoney(p.subtotal)}</span></div>
      ${
        showPix && paymentMethod === 'pix'
          ? `<div class="eden-totals__row eden-totals__row--discount"><span>Desconto 1ª compra</span><span>− ${formatMoney(p.discount)}</span></div>`
          : ''
      }
      <div class="eden-totals__row eden-totals__row--total"><span>Total</span><strong>${formatMoney(p.total)}</strong></div>
    `;
    if (mobilePriceEl) {
      mobilePriceEl.textContent = formatMoney(p.total);
    }
  }

  function updateUI() {
    const variant = findVariant();
    if (!variant) return;

    if (variantInput) variantInput.value = variant.id;
    if (specEl) specEl.textContent = variant.title === 'Default Title' ? '' : variant.title;

    optionGroups.forEach((group, index) => {
      const label = group.querySelector('[data-eden-option-label]');
      if (label && selectedOptions[index]) label.textContent = selectedOptions[index];
    });

    const p = calcPrices(variant);
    if (basePriceEl) basePriceEl.textContent = formatMoney(p.base);
    if (pixPriceEl) pixPriceEl.textContent = formatMoney(p.pix);
    if (simplePriceEl) simplePriceEl.textContent = formatMoney(variant.price);

    const addBtn = root.querySelector('[data-eden-add]');
    const buyBtn = root.querySelector('[data-eden-buy-now]');
    const soldOut = !variant.available;
    [addBtn, buyBtn, mobileBuy].forEach((btn) => {
      if (!btn) return;
      btn.disabled = soldOut;
    });
    if (addBtn) addBtn.textContent = soldOut ? 'Esgotado' : 'Adicionar à sacola';
    if (buyBtn && !soldOut) buyBtn.textContent = 'Comprar agora';
    if (mobileBuy && !soldOut) mobileBuy.textContent = 'Comprar agora';

    updateTotals(variant);

    const variantMedia = variant.featured_media?.preview_image?.src;
    if (variantMedia && mainImage) {
      mainImage.src = variantMedia;
      mainImage.srcset = '';
    }
  }

  async function addAndMaybeCheckout({ checkout }) {
    const variant = findVariant();
    if (!variant?.available) return;
    if (checkout) {
      await edenAddToCart({ variantId: variant.id, quantity, openDrawer: false });
      window.location.href = '/checkout';
      return;
    }
    await edenAddToCart({ variantId: variant.id, quantity, openDrawer: true });
  }

  optionGroups.forEach((group) => {
    const index = Number(group.dataset.edenOption);
    group.querySelectorAll('[data-eden-option-value]').forEach((btn) => {
      btn.addEventListener('click', () => {
        selectedOptions[index] = btn.dataset.edenOptionValue;
        group.querySelectorAll('[data-eden-option-value]').forEach((b) => {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        updateUI();
      });
    });
  });

  qtyMinus?.addEventListener('click', () => {
    quantity = Math.max(1, quantity - 1);
    if (qtyValue) qtyValue.textContent = String(quantity);
    updateUI();
  });

  qtyPlus?.addEventListener('click', () => {
    quantity = Math.min(10, quantity + 1);
    if (qtyValue) qtyValue.textContent = String(quantity);
    updateUI();
  });

  paymentBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      paymentMethod = btn.dataset.edenPayment;
      paymentBtns.forEach((b) => b.classList.toggle('is-active', b === btn));
      updateUI();
    });
  });

  thumbBtns.forEach((btn, i) => {
    btn.addEventListener('click', () => setMedia(i));
  });

  galleryPrev?.addEventListener('click', () => setMedia(currentMediaIndex - 1));
  galleryNext?.addEventListener('click', () => setMedia(currentMediaIndex + 1));

  form?.addEventListener('submit', async (event) => {
    event.preventDefault();
    const btn = event.submitter;
    try {
      await addAndMaybeCheckout({ checkout: Boolean(btn?.dataset?.edenBuyNow) });
    } catch (err) {
      console.error(err);
    }
  });

  mobileBuy?.addEventListener('click', async () => {
    try {
      await addAndMaybeCheckout({ checkout: true });
    } catch (err) {
      console.error(err);
    }
  });

  updateUI();
}

document.querySelectorAll('[data-eden-product]').forEach(initProductPage);

document.querySelectorAll('[data-eden-card-add]').forEach((btn) => {
  btn.addEventListener('click', async (event) => {
    event.preventDefault();
    const variantId = btn.dataset.edenCardAdd;
    if (!variantId || btn.disabled) return;
    btn.disabled = true;
    const label = btn.textContent;
    btn.textContent = 'Adicionando…';
    try {
      await edenAddToCart({ variantId, quantity: 1, openDrawer: true });
      btn.textContent = 'Adicionado';
      setTimeout(() => {
        btn.textContent = label;
        btn.disabled = false;
      }, 1500);
    } catch {
      btn.textContent = label;
      btn.disabled = false;
    }
  });
});
